/* PJ luxury pages: swipe dots, sticky booking bar, contents highlight. Added 15 Oct 2026. */
(function () {
  if (window.__pjLux) return; window.__pjLux = true;
  function init() {
    document.querySelectorAll('.pjl-swipe').forEach(function (track) {
      if (track.__pj) return; track.__pj = true;
      var dots = track.parentNode.querySelector('.pjl-dots');
      if (!dots) return;
      var items = track.children;
      dots.innerHTML = '';
      for (var i = 0; i < items.length; i++) dots.appendChild(document.createElement('span'));
      var spans = dots.children;
      function mark() {
        var c = track.getBoundingClientRect(), mid = c.left + c.width / 2, best = 0, bestD = Infinity;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        }
        for (var j = 0; j < spans.length; j++) spans[j].classList.toggle('is-active', j === best);
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      mark();
    });
    var bar = document.querySelector('.pjl-sticky');
    var hero = document.querySelector('[data-pjl-hero]');
    if (bar && hero && 'IntersectionObserver' in window && !bar.__pj) {
      bar.__pj = true;
      new IntersectionObserver(function (e) { bar.classList.toggle('is-on', !e[0].isIntersecting); }).observe(hero);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
